import { bindable, BindingMode, inject } from "aurelia";

@inject(Element)
/**
 * Use this as a standard input field. If you need to use html attribute tabindex use
 * template bindable attribute "t-i" in the input-field custom element.
 *
 * For max length use attribute "l"
 *
 * For placeholder use "p-h" (pH)  (other than default which is "Ange + label")
 */
export class InputFieldCustomElement {
  @bindable({ mode: BindingMode.twoWay }) value;
  @bindable l = 30;
  @bindable pH = "";
  @bindable tI;
  @bindable t = "text";
  @bindable max;
  @bindable min;
  @bindable helpText;
  @bindable helpTextPosition = "right";
  @bindable helpTextTrigger = "focus";
  @bindable showMax = false;
  @bindable id;

  constructor(element) {
    this.element = element;
  }

  attached() {
    if (this.id) {
      this.input.id = this.id;
      this.label.setAttribute("for", this.id);
      this.element.removeAttribute("id");
    }
    if (!this.pH) this.placeholder = "";
    //if (!this.l) this.input.removeAttribute("maxlength"); // if not removed default becomes 0 chars.
    if (!this.tI) this.input.removeAttribute("tabindex"); //remove attribute to let browser handle tab order
    if (!this.pH) this.pH = this.getPlaceholder();
    if (!this.max) this.input.removeAttribute("max");
    if (!this.min) this.input.removeAttribute("min");

    if (this.t === "number") {
      this.input.type = "number";
    }

    if (this.t === "email") {
      this.input.type = "email";
    }
  }

  getPlaceholder() {
    const projected = [...this.label.childNodes].find(
      (node) => node.nodeType === Node.TEXT_NODE && node.wholeText.trim() !== ""
    );
    return "Ange " + (projected?.wholeText.trim() ?? "").toLowerCase();
  }

  addErrorClass() {
    this.input ? this.input.classList.add("has-error") : {};
  }

  removeErrorClass() {
    this.input ? this.input.classList.remove("has-error") : {};
  }
}
